import {put, call , takeLatest} from "redux-saga/effects"
import {actions} from './Reducer'
import {getUsersReportsSuccessAction , setUsersReportsCountAction , setUsersReportsIsLoadingAction} from "./Actions"
import * as Api from "../../users/Api"


function* getUsersReports({payload}){

    const defData = {
        "offset": 0,
        "size": 20,
        "searchTerm": "",
        "sort": "email",
        "dir": "asc"
    }

    const body = {...defData , ...payload}

    try {
        yield put(setUsersReportsIsLoadingAction(true))
        const response  = yield call(Api.getUsers , body)
        const { data } = response;
        const count = data.count;
        const users = data.content;

        yield put(getUsersReportsSuccessAction(users))
        yield put(setUsersReportsCountAction(count))

    }catch(error){
        console.log(error)
    }finally{
        yield put(setUsersReportsIsLoadingAction(false))
    }
}

export default function*(){
    yield takeLatest(actions.REPORTS_GET_USERS , getUsersReports)
}

